import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import FacilityBanner from "./facilty-asset-management-banner";
import FacilityInfo from "./facility-asset-management-info";
function AICustomerSupport() {
  return (
    <>
      <Header />
      <main>
        <FacilityBanner />
        <FacilityInfo />
      </main>
      <Footer />
    </>
  );
}

export default AICustomerSupport;
